<template>
    <div class="filter overflow-hidden px-2 lg:px-0">
      <div class="">
        <div class="relative row" :style="backgroundImageStyle">
          <slot name="block-overlay"></slot>
          <div class="col-lg-9 col-xxl-9 mx-auto lg:px-0 pt-5 relative">
            <slot name="block-title"></slot>
          </div>
          <div class="col-lg-9 lg:px-0 mx-auto relative">
            <form @submit.prevent="fetchResults(1)" class="w-full">
              <p class="font-normal text-2xl lg:hidden">Filter vacancies</p>
              <div class="keyword-search__container">
                <div class="filter__bar w-full flex flex-col lg:flex-row lg:items-end mb-2 lg:mb-3">
                  <div class="filter__bar-item w-full lg:mr-3">
                    <div class="dropdown">
                      <h6 class="font-normal">Search</h6>
                      <input
                        v-model="filters.search"  
                        class="form-control border border-gray-300 p-2 rounded w-full text-black"
                        placeholder="Enter a query to begin your search..."
                      />
                    </div>
                  </div>
                  <div class="filter__btn hidden lg:block w-full">
                    <button
                      type="submit"
                      class="btn btn-primary uppercase bg-marigold rounded-full shadow-sm text-sm text-white mx-auto transition-all duration-500 hover:bg-light-cyan font-normal py-3 w-full"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
              <div class="filter__btn lg:hidden w-full mt-2 mb-3">
                <button
                  type="submit"
                  class="btn btn-primary uppercase bg-marigold rounded-full shadow-sm text-xs text-white mx-auto transition-all duration-500 hover:bg-light-cyan font-normal py-2 w-full"
                >
                  Show results
                </button>
              </div>
              <div class="filter__bar w-full flex flex-wrap lg:flex-nowrap items-end pt-2 lg:pt-0">
                <div class="filter__bar-item w-full lg:mr-3 mb-2 lg:mb-0">
                  <div class="dropdown">
                    <h6 class="font-normal">Job Type</h6>
                    <select
                      v-model="filters.type"
                      class="form-control form-select font-light border border-gray-300 p-2 rounded"
                    >
                      <option value="">Show All</option>
                      <option
                        v-for="type in allCareerTypes"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.Title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="filter__bar-item w-full lg:mr-3 mb-2 lg:mb-0">
                  <div class="dropdown">
                    <h6 class="font-normal">Location</h6>
                    <select
                      v-model="filters.location"
                      class="form-select form-control font-light border border-gray-300 p-2 rounded"
                    >
                      <option value="">Show All</option>
                      <option
                        v-for="location in allCareerLocations"
                        :key="location.id"
                        :value="location.id"
                      >
                        {{ location.Title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="filter__bar-item w-full mb-2 lg:mb-0">
                  <div class="dropdown">
                    <h6 class="font-normal">Business area</h6>
                    <select
                      v-model="filters.businessArea"
                      class="form-control form-select font-light border border-gray-300 p-2 rounded"
                    >
                      <option value="">Show All</option>
                      <option
                        v-for="area in allCareerAreas"
                        :key="area.id"
                        :value="area.id"
                      >
                        {{ area.Title }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="filter__advance-reset flex justify-center lg:justify-start mt-4">
                <a
                  class="form__reset font-normal flex items-center pl-2"
                  href="#"
                  @click.prevent="resetFilters"
                >
                  <span class="underline">Reset filters</span>
                  <i class="fas fa-redo reset ml-2"></i>
                </a>
              </div>
            </form>
          </div>
  
          <div id="paginated-target" class="py-5 relative">
            <!-- Results -->
            <div v-if="results && results.length > 0">
              <div
                v-for="result in results"
                :key="result.id"
                class="result-item border-b mb-4 pt-4"
              >
                <div class="mb-4">
                  <a
                      class="hover:text-marigold"
                      :href="'https://mahi.ngaitahu.iwi.nz/jobdetails?ajid=' + result.IdAPI"
                      target="_blank"
                  >
                  <h3 class="text-xl hover:text-marigold">{{ result.SearchTitle || result.MenuTitle || result.Title }}</h3>
                  </a>
                  <p class="mb-3  font-light">{{ result.MetaDescription }}</p>
                  <h4 class="text-lg ">
                    <small>
                      <strong>
                        {{ result.BusinessAreas.join(', ') }}
                      </strong>
                      |
                      Location:
                      <strong>
                        {{ result.Locations.join(', ') }}
                      </strong>
                      |
                      Type:
                      <strong>
                        {{ result.JobTypes.join(', ') }}
                      </strong>
                      |
                      Expertise:
                      <strong>
                        {{ result.Expertises.join(', ') }}
                      </strong>
                    </small>

                  </h4>
  
                  <h5 class="mb-3 font-normal text-primary">
                      <small>
                          Posted:  {{ formatDate(result.DateStart) }}
                          |
                          Closes: {{ formatDate(result.DateUntil) }}
                      </small>
                  </h5>
                  <a
                      class="btn btn-primary px-4 text-sm sm:text-xs lg:text-base uppercase"
                      :href="'https://mahi.ngaitahu.iwi.nz/jobdetails?ajid=' + result.IdAPI"
                      target="_blank"
                      :title="`Read more about on ${result.Title}`"
                      >
                      Apply now
                  </a>
  
  
                </div>
              </div>
              <pagination
                :total-pages="totalPages"
                :current-page="currentPage"
                @page-changed="fetchResults"
              />
            </div>
            <p v-else>No results found.</p>
          </div>

        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Pagination from './Pagination.vue';

  export default {
    props: {
      allCareerTypes: {
        type: Array,
        required: true,
      },
      allCareerLocations: {
        type: Array,
        required: true,
      },
      allCareerAreas: {
        type: Array,
        required: true,
      },
      blockId: {
        type: String,
        required: true,
      },
    },
    components: {
      Pagination,
    },
    data() {
      return {
        filters: {
          search: '',
          type: '',
          location: '',
          businessArea: '',
        },
        results: [],
        totalPages: 0,
        currentPage: 1,
        backgroundImageStyle: '', 
      };
    },
    methods: {
      fetchResults(page = 1) {
        this.currentPage = page;  
        // console.log("current page : ", this.currentPage);
            
        const query = {
          search: this.filters.search,
          type: this.filters.type,
          location: this.filters.location,
          businessArea: this.filters.businessArea,
          page: this.currentPage,
          blockID: this.blockId,
        };
        axios
          .get('/career-results', { params: query })
          .then((response) => {
            this.results = response.data.Results || [];
            this.totalPages = response.data.TotalPages || 1;
            // console.log(this.results);
            // Check if results are empty and update filters.businessArea
            if (this.results.length === 0) {
              this.filters.businessArea = '';
              this.fetchResults();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      resetFilters() {
        this.filters = {
          search: '',
          type: '',
          location: '',
          businessArea: '',
        };
        this.fetchResults();
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
    mounted() {
      // Prepopulate the businessArea filter with 7 on the initial load
      this.filters.businessArea = '7';
      this.fetchResults(); // Fetch initial results on mount
    },
  };
  </script>
  